module.exports = __webpack_public_path__ + "img/kuai.6e7b600c.png";